function waitForMessage(matchFn: (event: any) => boolean, timeout = 4000) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      cleanup()
      reject(new Error("Request timed out"))
    }, timeout)

    const handler = (event: any) => {
      if (!matchFn(event)) return
      cleanup()
      resolve(event.data.payload?.data || event.data.payload?.linkedinUrl)
    }

    function cleanup() {
      clearTimeout(timer)
      window.removeEventListener("message", handler)
    }

    window.addEventListener("message", handler)
  })
}

export function getLinkedinCookie() {
  if (!document.querySelector("orbitshift-ui")) {
    return Promise.reject(new Error("UI not found"))
  }

  window.postMessage(
    {
      source: "orbitshift",
      type: "FETCH_LINKEDIN_COOKIE",
      payload: { websiteName: "LinkedIn" }
    },
    "*"
  )

  return waitForMessage(
    (event) =>
      event.data?.source === "orbitshift" &&
      event.data?.type === "response" &&
      event.data?.payload?.type === "FETCH_LINKEDIN_COOKIE"
  )
}

export function connectLinkedin(
  linkedin_url: string,
  name: string,
  note: string
) {
  window.postMessage(
    {
      source: "orbitshift",
      type: "SEND_LINKEDIN_MESSAGE",
      payload: { linkedin_url, name, note }
    },
    "*"
  )
  return Promise.resolve(true)
}

export function getLinkedinUrl() {
  window.postMessage(
    {
      source: "orbitshift",
      type: "FETCH_LINKEDIN_URL"
    },
    "*"
  )

  return waitForMessage(
    (event) =>
      event.data?.source === "orbitshift" &&
      event.data?.type === "response" &&
      event.data?.payload?.type === "FETCH_LINKEDIN_URL"
  )
}
